import RfiSpreadsheetCategoriesTable from './RfiSpreadsheetCategoriesTable.component';

export default RfiSpreadsheetCategoriesTable;
